import { helper } from './helper';

export const calcCurrency = (val1: number | string, val2: number | string, amount: number | string) => (
    ((helper.deleteNotNumbersAndParseFloatSmallNumber(String(val1)).number || 1) *
      helper.deleteNotNumbersAndParseFloatSmallNumber(String(amount)).number) /
    (helper.deleteNotNumbersAndParseFloatSmallNumber(String(val2)).number || 1)
  );
